// extracted by mini-css-extract-plugin
export default {"root":"PopularSearches-root","Pill":"PopularSearches-Pill","itemLink":"PopularSearches-itemLink"};